module.exports = {
  schema: {
    name: '折射率資料',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '折射率代碼',
      },
      name: {
        type: 'String',
        name: '折射率名稱',
      },
      refraction: {
        type: 'String',
        name: '折射率',
      },
      material: {
        type: 'String',
        name: '鏡片材料',
      },
    },
  },
  index: {
    primary: {
      key: {
        name: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 100 },
        { key: 'name', width: 200 },
        { key: 'refraction' },
        { key: 'material', width: 90 },
      ],
    },
    editor: {
      config: { titleMd: 2, titleSm: 2 },
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'name' }],
            [{ key: 'refraction' }],
            [{ key: 'material' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/lensRefractions.js